import {
  Paper,
  Grid,
  CircularProgress,
  withStyles,

} from "@material-ui/core";
import { connect } from "react-redux";
import { styles } from "./Preview.css";
import clsx from "clsx";
import i18n from "i18next";
import React, { Component } from "react";
import CloseIcon from "@material-ui/icons/Close";
import {
  showCtagRulePreview
} from "../../redux/actions/MlTrackLibraryActions";

// import trackFields from "../../_module/definition/trackFields";




class CtagRulePreview extends Component {
  constructor(props) {
    super();
    this.state = {

    };
  }

  cancelHandle = () => {
    const { showCtagRulePreview } = this.props;
    showCtagRulePreview(false);
  }

  setConditions = (condition) => {
    var matchedCondition;
    switch (condition) {
      case 1:
        matchedCondition = "Exactly";
        break;
      case 2:
        matchedCondition = "Contains";
        break;
      case 3:
        matchedCondition = "Starts With";
        break;
      case 4:
        matchedCondition = "Ends With";
        break;
      case 5:
        matchedCondition = "Not Contains";
        break;
      case 6:
        matchedCondition = "Exact Word";
        break;
      case 7:
        matchedCondition = "Boolean";
        break;
      default:
        matchedCondition = "";
    }
    return matchedCondition;
  }

  setProperty = (property) => {
    const {
    orgRuntime: {
      runtime: {
        _trackFields: trackFields,
    
      }
    } 
  } = this.props;
    var selectedProperty = "";
    if (property) {     

      Object.keys(trackFields).map((v, i) => {
        if (property == trackFields[v].id) {
          selectedProperty = i18n.t(`modules.${trackFields[v].id}`);
        }
      })
      return selectedProperty;
    }
  }


  render() {
    const {
      classes,
      data: { ctagRuleList, ctagRuleBusy, cTagType }
    } = this.props;

    return (
      <>
        <Paper className={classes.globalCreateBody}>
          <Grid container className={clsx(classes.globalCreateInput, "onlyPopup")}>
            
              
                <>
                 
                    <Grid container className={classes.globalInput}>
                        <Grid item xs={12}>
                      <div className={clsx(classes.buildEditorBlock, "ctagWindow")} >
                        <div >
                          <div className={classes.buildRuleName} >
                            {ctagRuleBusy && <div className={classes.buildRuleContainer} ><CircularProgress className={classes.circularProgress} /></div>}
                            {ctagRuleList && ctagRuleList.length > 0 ? ctagRuleList.map((ruleList, i) =>
                              <>
                                <div className={classes.buildRuleRow}>
                                  <div className={classes.ruleDetails}>
                                    {ruleList ? <div className={classes.ruleData}><span title={`Rule Number: ${ruleList.ruleDetails.ruleId}`}>{ruleList.ruleDetails.ruleId}</span><span title={`Rule Name: ${ruleList.ruleDetails.ruleName}`}>{ruleList.ruleDetails.ruleName}</span> </div> : null}
                                    {ruleList ? <div title={ruleList.cTag.name} className={`explicitContents overideTagstyles cTag1`} style={{ fontSize: "10px", background: ruleList.cTag.colour, color: "#fff" }}>{ruleList.cTag.indicator}</div> : null}
                                  </div>
                                  {
                                    ruleList ? ruleList.conditions.map((rule, x) =>
                                      <>
                                        <div >
                                          {rule.defaultItem ?
                                            <>
                                              <div>
                                                <span>{this.setProperty(rule.defaultItem.property)} </span>
                                                <span>{this.setConditions(rule.defaultItem.condition)} </span>
                                                <span>{`'${rule.defaultItem.value}'`}</span>
                                              </div>
                                            </>
                                            : null
                                          }
                                        </div>
                                        <div className={classes.conditionTag}>
                                          {rule.and ?
                                            <>
                                              <span className={classes.ruleTriggerLabel}>AND</span>
                                              <div>
                                                <span>{this.setProperty(rule.and.property)} </span>
                                                <span>{this.setConditions(rule.and.condition)} </span>
                                                <span>{`'${rule.and.value}'`}</span>
                                              </div>
                                            </>
                                            : null
                                          }
                                        </div>
                                        <div className={classes.conditionTag}>
                                          {rule.or && rule.or.length > 0 ? rule.or.map((or) =>
                                            <>
                                              <span className={classes.ruleTriggerLabel}>OR</span>
                                              <div>
                                                <span>{this.setProperty(or.property)} </span>
                                                <span>{this.setConditions(or.condition)} </span>
                                                <span>{`'${or.value}'`}</span>
                                              </div>
                                            </>
                                          ) : ""}

                                          {ruleList?.ruleDetails?.notes && ruleList.conditions.length - 1 == x ? <div className={classes.ruleData} style={{
                                            borderTop: "1px solid #999",
                                            display: "block",
                                            marginTop: "10px",
                                            paddingTop: "10px",
                                            color: "#999",
                                          }}><span >Notes : </span><span title={ruleList.ruleDetails.notes}>{ruleList.ruleDetails.notes}</span> </div> : null}

                                        </div>
                                      </>
                                    ) : <div className={clsx(classes.noData, "noData")}>
                                      No C-Tags Found
                                    </div>}
                                </div>
                              </>
                            ) : !ctagRuleBusy && <div className={clsx(classes.noData, "noData")}>
                              No C-Tags Found
                            </div>}
                          </div>
                        </div>
                      </div>
                    

                      </Grid>
                    </Grid>
                   
                </>
               
             
          </Grid>
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mltracklibrary,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  showCtagRulePreview
})(withStyles(styles)(CtagRulePreview));
